import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "section1-background"
};
const _hoisted_2 = {
  class: "section no-video",
  id: "section1"
};
const _hoisted_3 = {
  class: "text1"
};
const _hoisted_4 = {
  class: "text2"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = {
  class: "patch-notes-button button6"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-over"
}, null, -1);
const _hoisted_8 = {
  class: "button-text"
};
const _hoisted_9 = {
  class: "video-content"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "borders"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "border-top"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "border-fill"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "border-bottom"
})], -1);
const _hoisted_11 = {
  class: "video-thumbnail"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "play-button-over"
}, null, -1);
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  class: "section",
  id: "section2"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "section-left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "section-corner"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "section-corner-fill"
})], -1);
const _hoisted_16 = {
  class: "section-content"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "text1"
}, "Complete Your Progression and Unlock Exclusive Rewards!", -1);
const _hoisted_18 = {
  class: "text2"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "bold"
}, "earn more FREE rewards!", -1);
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "text3"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "bold"
}, "00"), /*#__PURE__*/_createTextVNode(" days left!")], -1);
const _hoisted_22 = {
  class: "progress-content"
};
const _hoisted_23 = {
  class: "logged-out"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "learn-more-button button3"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "button-over"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "button-text"
}, "Learn More")], -1);
const _hoisted_25 = {
  class: "logged-in"
};
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"progress-bar\"><div class=\"progress-left\"></div><div class=\"progress-item\"></div><div class=\"progress-divider\"></div><div class=\"progress-item\"></div><div class=\"progress-divider\"></div><div class=\"progress-item\"></div><div class=\"progress-divider\"></div><div class=\"progress-item\"></div><div class=\"progress-divider\"></div><div class=\"progress-item\"></div><div class=\"progress-divider\"></div><div class=\"progress-item\"></div><div class=\"progress-divider\"></div><div class=\"progress-item\"></div><div class=\"progress-right\"></div></div><br class=\"show-for-medium-only\">", 2);
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "learn-more-button button3"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "button-over"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "button-text"
}, "Learn More")], -1);
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<br class=\"show-for-large\"><div class=\"progress-text\"><div class=\"current\">0</div> / <div class=\"total\">7</div></div><div class=\"complete-text\"> COMPLETE! <div class=\"gift\"></div></div>", 3);
const _hoisted_32 = {
  class: "section",
  id: "section3"
};
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "section-corner"
}, null, -1);
const _hoisted_34 = {
  class: "section-content"
};
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "text1"
}, "Register for the Override Registration Event and Earn a FREE Prize Package!", -1);
const _hoisted_36 = {
  class: "text2"
};
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", {
  class: "bold"
}, " FREE exclusive gift pack", -1);
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "text3"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "bold"
}, "00"), /*#__PURE__*/_createTextVNode(" days left!")], -1);
const _hoisted_40 = {
  class: "progress-content"
};
const _hoisted_41 = {
  class: "logged-out"
};
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "learn-more-button button3"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "button-over"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "button-text"
}, "Learn More")], -1);
const _hoisted_43 = {
  class: "logged-in"
};
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "progress-bar-short"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "progress-left"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "progress-item"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "progress-right"
})], -1);
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "learn-more-button button3"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "button-over"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "button-text"
}, "Learn More")], -1);
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  class: "registered-text"
}, [/*#__PURE__*/_createTextVNode(" REGISTERED! "), /*#__PURE__*/_createElementVNode("div", {
  class: "gift"
})], -1);
const _hoisted_47 = {
  class: "section-background"
};
const _hoisted_48 = {
  class: "section-content"
};
const _hoisted_49 = {
  class: "text1"
};
const _hoisted_50 = {
  class: "text2"
};
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "button3 learn-more-button"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "button-over"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "button-text"
}, "Learn More")], -1);
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", {
  class: "footer-top"
}, null, -1);
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", {
  class: "m-lightbox__inner-wrapper"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "m-lightbox__media"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "m-lightbox__media-video"
}, [/*#__PURE__*/_createElementVNode("iframe", {
  class: "m-lightbox__media-video-iframe",
  width: "560",
  height: "315",
  src: "https://www.youtube.com/embed/GYJOnrIMdb8?autoplay=1&autohide=1&controls=1&loop=0&rel=0&fs=1&wmode=transparent&showinfo=0&modestbranding=1&iv_load_policy=1&start=0&theme=dark&color=red&playsinline=false&enablejsapi=1&origin=https%3A%2F%2Fnexon.com&widgetid=1",
  frameborder: "0",
  allowscriptaccess: "always",
  allowfullscreen: "true"
})])])], -1);
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-x"
}, null, -1);
const _hoisted_55 = [_hoisted_54];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "mobile-bg",
    style: _normalizeStyle({
      backgroundImage: `url(${_ctx.banner.ImageMobileBanner})`
    })
  }, null, 4), _createElementVNode("div", {
    class: "desktop-bg",
    style: _normalizeStyle({
      backgroundImage: `url(${_ctx.banner.ImageBanner})`
    })
  }, null, 4)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.banner.Title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.banner.Summary), 1), _ctx.banner.CTAButtonDisplay && _ctx.banner.CTAButtonUrls.length > 0 ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    href: _ctx.banner.CTAButtonUrls[0].link,
    target: "_blank"
  }, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.banner.CTAButtonCopy), 1)])], 8, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "play-button",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.openModal && _ctx.openModal(...args)),
    id: "video-button1"
  }, _hoisted_13)])])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createTextVNode(" Journey to Override by completing steps on this site! You’ll be able to "), _hoisted_19, _createTextVNode(), _hoisted_20, _createTextVNode("*Restrictions apply. "), _createVNode(_component_router_link, {
    to: "/micro-site/override/journey"
  }, {
    default: _withCtx(() => [_createTextVNode("CLICK")]),
    _: 1
  }), _createTextVNode(" for full details* ")]), _hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_router_link, {
    to: "/micro-site/override/journey"
  }, {
    default: _withCtx(() => [_hoisted_24]),
    _: 1
  })]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createVNode(_component_router_link, {
    to: "/micro-site/override/journey"
  }, {
    default: _withCtx(() => [_hoisted_28]),
    _: 1
  }), _hoisted_29])])])]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", _hoisted_36, [_createTextVNode(" Log in and register for the event to earn a "), _hoisted_37, _createTextVNode(" full of useful items! "), _hoisted_38, _createTextVNode("*Restrictions apply. "), _createVNode(_component_router_link, {
    to: "/micro-site/override/register"
  }, {
    default: _withCtx(() => [_createTextVNode("CLICK")]),
    _: 1
  }), _createTextVNode(" for full details* ")]), _hoisted_39, _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createVNode(_component_router_link, {
    to: "/micro-site/override/register"
  }, {
    default: _withCtx(() => [_hoisted_42]),
    _: 1
  })]), _createElementVNode("div", _hoisted_43, [_hoisted_44, _createVNode(_component_router_link, {
    to: "/micro-site/override/register"
  }, {
    default: _withCtx(() => [_hoisted_45]),
    _: 1
  }), _hoisted_46])])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, article => {
    return _openBlock(), _createElementBlock("div", {
      key: article.Id,
      class: "section misc"
    }, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", {
      class: "mobile-bg",
      style: _normalizeStyle({
        backgroundImage: `url(${article.ImageMobile})`
      })
    }, null, 4), _createElementVNode("div", {
      class: "desktop-bg",
      style: _normalizeStyle({
        backgroundImage: `url(${article.ImageThumbnail})`
      })
    }, null, 4)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(article.Title), 1), _createElementVNode("div", _hoisted_50, _toDisplayString(article.Summary), 1), _createVNode(_component_router_link, {
      to: `/micro-site/override/${article.Id}/${article.SEOLink ? article.SEOLink : ''}`
    }, {
      default: _withCtx(() => [_hoisted_51]),
      _: 2
    }, 1032, ["to"])])]);
  }), 128)), _hoisted_52, _ctx.videoModal ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "m-lightbox active",
    onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => _ctx.closeModal && _ctx.closeModal(...args), ["self"]))
  }, [_hoisted_53, _createElementVNode("i", {
    id: "cboxClose",
    class: "m-lightbox__ui-close",
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.closeModal && _ctx.closeModal(...args))
  }, _hoisted_55)])) : _createCommentVNode("", true)]);
}